import React from "react"
import { useTranslation } from "react-i18next"

import { Card } from "~/components/Card/Card"
import { Akkredit } from "~/components/Akkredit/Akkredit"
import { Heading } from "~/components/Heading/Heading"
import { Link } from "~/components/Link/Link"
import { Raw } from "~/components/raw"
import { Theme } from "~/components/Theme/Theme"
import { Wrapper } from "~/components/Wrapper/Wrapper"

import styles from "./index.module.css"

export const Cards: React.FC = () => {
  const { t } = useTranslation()

  return (
    <div id="cards">
      <Theme theme="light">
        <Wrapper>
          <div className="container">
            <div className={styles.Wrapper}>
              <Akkredit />
            </div>
          </div>
        </Wrapper>
      </Theme>
    </div>
  )
}
